module.exports = __webpack_public_path__ + "static/media/solana-logo.36893fd6.svg";